import { render, staticRenderFns } from "./WellItem.vue?vue&type=template&id=2b019c4c&"
import script from "./WellItem.vue?vue&type=script&lang=ts&"
export * from "./WellItem.vue?vue&type=script&lang=ts&"
import style0 from "./WellItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports